module.exports = __webpack_public_path__ + "static/vitrine_moi_v1-6d6ec2e5a59cd7bdc12c03fc6aa3c7b5.png";